import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useHttp} from "../../hooks/http.hook";
import {AuthContext} from "../../context/AuthContext";
import {General_API} from "../../Roles/General/General_API";
import LiveSearchInput from "../LiveSearchInput";
import {trim} from "../../utils/utils";

ApiSearchInput.propTypes = {
    orgType: PropTypes.oneOf(['verificationCenter', 'medcenter', 'allOrganizations', 'organization']),
    chooseHandler: PropTypes.func,
    initialValue: PropTypes.string,
    title: PropTypes.string
};

function ApiSearchInput(props) {
    const {request} = useHttp()
    const {token} = useContext(AuthContext)
    const [requestStorage, setRequestStorage] = useState([])
    const [selectedOption, setSelectedOption] = useState({})
    const [initialValue, setInitialValue] = useState(props.initialValue)
    const [isFirstOpen, setFirstOpen] = useState(true)
    const {orgsSearch} = General_API.liveSearch
    const searchRequest = async (orgName) => {
        const {
            status,
            data
        } = await request(process.env.REACT_APP_BASE_URL + orgsSearch(orgName ? trim(orgName) : '', props.orgType).api, "GET", null, {Authorization: `Bearer ${token.token}`})
        status === 200 && setRequestStorage(data?.data?.length ? data?.data?.map((item) => {
            return {show: item.name, id: item.id}
        }): () => ([]))
    }

    const changeHandler = (data) => {
        props.chooseHandler(data.id, data.name)
        setSelectedOption(data)
    }

    useEffect(() => {
        if (isFirstOpen) {

            if (requestStorage[0] && initialValue) {
                requestStorage[0].show === initialValue && props.chooseHandler(requestStorage[0].id, requestStorage[0].show)
                setFirstOpen(false)
            }
        }
    }, [requestStorage])

    useEffect(() => {
        selectedOption.name && setInitialValue(selectedOption.name)
    }, [selectedOption])

    return (<>
            <input style={{display: 'none'}} ref={props.reff} name={props.name} type="text"/>
            <LiveSearchInput initialValue={initialValue}
                             optionClickHandler={changeHandler}
                             onChange={searchRequest}
                             disabled={props.disabled}
                             storage={requestStorage}
                             maxHeight={props.maxHeight}
                             important={props.important}
                             title={props.title}
                             placeholder={props.placeholder}
                             icon={props.icon}
            />
        </>
    );
}

export default ApiSearchInput;